import {
  Button,
  Card,
  Divider,
  Grid,
  MenuItem,
  Snackbar,
  Table,
  TableBody,
  TableHead,
  Typography,
  IconButton,
  Alert as MuiAlert,
  TextField,
  Box,
  CardContent,
  Stack,
  Tooltip,
  TableContainer,
} from '@mui/material'
import { Edit as EditIcon } from '@mui/icons-material'
import { useEffect, useState, forwardRef } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import { businessCheck } from '../../utils/utils'
import HeaderFooterDrawer from './headerfooter/headerFooterDrawer'
import { ErrorScreen, ShowNoRecordsFound, SnackBarHideDuration, SnackBarTransition, StyledTableCell, StyledTableRow } from '../../utils/ui_utils'
import { useFetchOutlet } from '../../modules/outlet/outletHooks';
import { useCreateHeaderFooter, useFetchHeaderFooter, useUpdateHeaderFooter } from '../../modules/headerFooter/headerFooterHooks';
import ListTypeShimmer from '../../utils/ui_components/shimmers/listTypeShimmer';


function TerminalHeaderFooter() {
  const [selectedOutlet, setSelectedOutlet] = useState('')
  const [selectedOutletName, setSelectedOutletName] = useState('')
  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)
  const [headerFooterDrawerMode, setHeaderFooterDrawerMode] = useState('new')
  const [headerFooterDrawerVisibility, setHeaderFooterDrawerVisibility] = useState(false)
  const [headerfooterData, setHeaderFooterData] = useState(undefined)
  const [noRecordsFound, setNoRecordsFound] = useState(false)
  const [outlets, setOutlets] = useState([])
  const { outletFetch, outletFetchData, outletFetchError, outletFetchLoading } = useFetchOutlet();
  const { headerFooterFetchData, headerFooterFetchError, headerFooterFetchLoading, fetchHeaderFooter } = useFetchHeaderFooter();
  const { createHeaderFooter } = useCreateHeaderFooter();
  const { updateHeaderFooter } = useUpdateHeaderFooter();

  const defaultHeaderFooter = {
    Footer: [
      {
        alignment: 'left',
        font: 'Times Roman',
        font_size: '18',
        line_number: 1,
        text: 'Thank You'
      },
      {
        alignment: 'left',
        font: 'Times Roman',
        font_size: '18',
        line_number: 2,
        text: ''
      },
      {
        alignment: 'left',
        font: 'Times Roman',
        font_size: '18',
        line_number: 3,
        text: ''
      },
      {
        alignment: 'left',
        font: 'Times Roman',
        font_size: '18',
        line_number: 4,
        text: ''
      },
      {
        alignment: 'left',
        font: 'Times Roman',
        font_size: '18',
        line_number: 5,
        text: ''
      }
    ],
    Header: [
      {
        alignment: 'center',
        font: 'Times Roman',
        font_size: '18',
        line_number: 1,
        text: ''
      },
      {
        alignment: 'left',
        font: 'Times Roman',
        font_size: '18',
        line_number: 2,
        text: ''
      },
      {
        alignment: 'left',
        font: 'Times Roman',
        font_size: '18',
        line_number: 3,
        text: ''
      },
      {
        alignment: 'left',
        font: 'Times Roman',
        font_size: '18',
        line_number: 4,
        text: ''
      },
      {
        alignment: 'left',
        font: 'Times Roman',
        font_size: '18',
        line_number: 5,
        text: ''
      }
    ]
  }

  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }

  const history = useNavigate()

  useEffect(() => {
    businessCheck(history)
    let payload = {
      pageNumber: 1,
      limit: 100
    }
    outletFetch(payload)
  }, [])

  const fetchOutletOnError = () => {
    let payload = {
      pageNumber: 1,
      limit: 100
    }
    outletFetch(payload)
  }


  const handleOutletChange = (event) => {
    setSelectedOutlet(event.target.value)
    fetchHeaderFooterOnError(event.target.value)
    let [outlet] = outletFetchData.data?.filter(outlet => outlet._id === event.target.value)
    setSelectedOutletName(outlet.name)
  }

  useEffect(() => {
    if (headerFooterFetchData.data?.Header?.length > 0) {
      setNoRecordsFound(false)
    }
    else {
      setNoRecordsFound(true)
    }

  }, [headerFooterFetchData.data])

  useEffect(() => {
    if (outletFetchData.data?.length > 0) {
      setOutlets(outletFetchData.data);
      setSelectedOutlet(outletFetchData.data[0]?._id)
      setSelectedOutletName(outletFetchData.data[0]?.name)
      fetchHeaderFooter(outletFetchData.data[0]?._id)
    } else {
      setOutlets([])
      setSelectedOutlet("")
      setSelectedOutletName("")
    }
  }, [outletFetchData])

  const fetchHeaderFooterOnError = (outletId) => {
    fetchHeaderFooter(outletId)
  }

  return (
    <>
      <Helmet title="Header Footer" />
      <Grid container sx={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}>

        <Grid item xs={9}>
          <Typography variant="h4" gutterBottom display="inline">
            Headers and Footers
          </Typography>
        </Grid>
      </Grid>
      <HeaderFooterDrawer
        visible={headerFooterDrawerVisibility}
        title={headerFooterDrawerMode == 'new' ? 'Create Header Footer' : 'Edit Header Footer'}
        okText={headerFooterDrawerMode == 'new' ? 'Create' : 'Update'}
        action={headerFooterDrawerMode}
        onClose={() => setHeaderFooterDrawerVisibility(false)}
        outletData={outletFetchData}
        initialValues={headerFooterDrawerMode == 'new' ? headerfooterData : headerFooterFetchData.data}
        onSubmit={async (value) => {
          let values = _.cloneDeep(value);
          if (headerFooterDrawerMode == 'new') {
            await createHeaderFooter(values, async (success, error, res) => {
              if (error) {
                toastMessage(res, 'error')
              } else {
                toastMessage(res, 'success')
                setHeaderFooterDrawerVisibility(false)
                await fetchHeaderFooter(selectedOutlet);
              }
            })
          }
          else {
            let outletid
            let flag = 0
            let flag1 = 0
            for (let i = 0; i < values.Header.length; i++) {
              values.Header[i].id = values.Header[i]._id
              if (
                flag === 0 &&
                values.Header[i].outlet_id !== null &&
                values.Header[i].outlet_id !== undefined
              ) {
                outletid = values.Header[i].outlet_id
                flag = 1
              }
              delete values.Header[i].outlet_id
              delete values.Header[i].business_id
              delete values.Header[i]._id
              delete values.Header[i].enable
            }
            for (let i = 0; i < values.Footer.length; i++) {
              values.Footer[i].id = values.Footer[i]._id
              if (
                flag1 === 0 &&
                values.Footer[i].outlet_id !== null &&
                values.Footer[i].outlet_id !== undefined
              ) {
                outletid = values.Footer[0].outlet_id
                flag1 = 1
              }
              delete values.Footer[i].outlet_id
              delete values.Footer[i].business_id
              delete values.Footer[i]._id
              delete values.Footer[i].enable
            }
            values.outlet_id = outletid

            await updateHeaderFooter(values, async (success, error, res) => {
              if (error) {
                toastMessage(res, 'error')
              } else {
                toastMessage(res, 'success')
                setHeaderFooterDrawerVisibility(false)
                await fetchHeaderFooter(selectedOutlet);
              }
            })
          }
        }}
      />
      <Divider style={{ paddingTop: 10 }} />
      {outletFetchError ? <ErrorScreen onClick={() => {
        fetchOutletOnError()
      }} /> :
        <div>
          <Grid container spacing={6} style={{ paddingTop: 10 }}>
            <Grid item md={3}>
              <TextField
                size="small"
                label="Outlet"
                id="outlet_id"
                name="outlet_id"
                variant="outlined"
                margin="dense"
                value={selectedOutlet}
                onChange={handleOutletChange}
                select
                fullWidth
              >
                {outlets.map((outlet) => (
                  <MenuItem key={outlet._id} value={outlet._id}>
                    {outlet.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
          {headerFooterFetchError ? <ErrorScreen onClick={() => {
            fetchHeaderFooterOnError(selectedOutlet)
          }} /> :
            <div>
              {
                (outletFetchLoading || headerFooterFetchLoading) && (<Grid container direction={'column'} spacing={10} sx={{ paddingTop: 10 }}>
                  <ListTypeShimmer />
                  <ListTypeShimmer />
                </Grid>
                )}
              {!outletFetchLoading && !headerFooterFetchLoading && outlets && outlets.length <= 0 && <ShowNoRecordsFound />}
              {!outletFetchLoading && !outletFetchError && !headerFooterFetchLoading && !headerFooterFetchError && outlets && outlets?.length > 0 && <Grid container>
                <Grid item md={12}>
                  <Box style={{ paddingTop: 20 }}>
                    {
                      (selectedOutlet == "") ? <></> : (noRecordsFound == true) ?
                        <Card raised style={{ width: '80%', borderRadius: 10 }}>
                          <CardContent>
                            <Stack direction="column" spacing={3} sx={{ margin: 10, alignItems: "center" }}>
                              <Typography variant='h5' component="span"> Headers and Footers are not avalable for this Outlet. </Typography>
                              <Button onClick={async () => {
                                defaultHeaderFooter.outlet_id = selectedOutlet;
                                defaultHeaderFooter.Header[0].text = selectedOutletName
                                await createHeaderFooter(defaultHeaderFooter, async (success, error) => {
                                  if (error) {
                                    toastMessage("Default Header Footer not created. Try Again.", 'error');
                                  }
                                  else {
                                    toastMessage("Default Header Footer created", 'success');
                                    await fetchHeaderFooter(selectedOutlet);
                                  }
                                })
                              }}>Create default Header Footer</Button>
                            </Stack>
                          </CardContent>
                        </Card>
                        :
                        <>
                          <Grid container spacing={10} sx={{ paddingTop: 5 }}>
                            <Grid item sm={8} md={6}>
                              <Card raised sx={{ borderRadius: 3 }}>
                                <CardContent>
                                  <Grid container spacing={6} sx={{ alignItems: "center" }} >
                                    <Grid item>
                                      <Typography variant='h4' gutterBottom display="inline">Headers</Typography>
                                    </Grid>
                                    <Grid item>
                                      <Tooltip title="Edit Header Footer" placement="bottom">
                                        <IconButton
                                          size="small"
                                          color="primary"
                                          component="span"
                                          onClick={() => {
                                            setHeaderFooterDrawerMode('edit')
                                            setHeaderFooterDrawerVisibility(true)
                                          }}
                                        >
                                          <EditIcon />
                                        </IconButton>
                                      </Tooltip>
                                    </Grid>
                                  </Grid>
                                  <Box sx={{ padding: 1 }}>
                                    <TableContainer component={Card} >
                                      <Table size="small">
                                        <TableHead>
                                          <StyledTableRow>
                                            <StyledTableCell sx={{ maxWidth: 50 }}>Line #</StyledTableCell>
                                            <StyledTableCell sx={{ minWidth: 150 }} align="left">Text</StyledTableCell>
                                            <StyledTableCell align="center">Alignment</StyledTableCell>
                                            <StyledTableCell align="center"> Font</StyledTableCell>
                                            <StyledTableCell sx={{ minWidth: 90 }} align="center"> Font Size</StyledTableCell>
                                          </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                          {headerFooterFetchData.data?.Header?.length > 0 &&
                                            headerFooterFetchData.data?.Header?.map((row, i) => (
                                              <StyledTableRow key={i}>
                                                <StyledTableCell sx={{ maxWidth: 50 }}>
                                                  {row.line_number}
                                                </StyledTableCell>
                                                <StyledTableCell sx={{ minWidth: 150 }} align="left">{row.text}</StyledTableCell>
                                                <StyledTableCell align="center">{row.alignment}</StyledTableCell>
                                                <StyledTableCell align="center">{row.font}</StyledTableCell>
                                                <StyledTableCell sx={{ maxWidth: 60 }} align="center">{row.font_size}</StyledTableCell>
                                              </StyledTableRow>
                                            ))}
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  </Box>
                                </CardContent>
                              </Card>
                              <Card raised sx={{ borderRadius: 3, mt: 10 }}>
                                <CardContent>
                                  <Grid container spacing={6} sx={{ alignItems: "center" }} >
                                    <Grid item>
                                      <Typography variant='h4' gutterBottom display="inline">Footers</Typography>
                                    </Grid>

                                  </Grid>
                                  <Box sx={{ padding: 1 }}>
                                    <TableContainer component={Card} >
                                      <Table size="small">
                                        <TableHead>
                                          <StyledTableRow>
                                            <StyledTableCell sx={{ maxWidth: 50 }}>Line #</StyledTableCell>
                                            <StyledTableCell sx={{ minWidth: 150 }} align="left">Text</StyledTableCell>
                                            <StyledTableCell align="center">Alignment</StyledTableCell>
                                            <StyledTableCell align="center"> Font</StyledTableCell>
                                            <StyledTableCell sx={{ minWidth: 90 }} align="center"> Font Size</StyledTableCell>
                                          </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                          {headerFooterFetchData.data?.Footer?.length > 0 &&
                                            headerFooterFetchData.data?.Footer?.map((row, j) => (
                                              <StyledTableRow key={j}>
                                                <StyledTableCell sx={{ maxWidth: 50 }}>
                                                  {row.line_number}
                                                </StyledTableCell>
                                                <StyledTableCell sx={{ minWidth: 150 }} align="left">{row.text}</StyledTableCell>
                                                <StyledTableCell align="center">{row.alignment}</StyledTableCell>
                                                <StyledTableCell align="center">{row.font}</StyledTableCell>
                                                <StyledTableCell sx={{ maxWidth: 60 }} align="center">{row.font_size}</StyledTableCell>
                                              </StyledTableRow>
                                            ))}
                                        </TableBody>
                                      </Table>
                                    </TableContainer>

                                  </Box>
                                </CardContent>
                              </Card>
                            </Grid>
                          </Grid>
                        </>
                    }
                  </Box>
                </Grid>
              </Grid>}
            </div>}
        </div>}

      <div>
        <Snackbar
          open={snackbar}
          autoHideDuration={SnackBarHideDuration}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={handleSnackbarClose}
          TransitionComponent={SnackBarTransition}
        >
          <Alert onClose={handleSnackbarClose} severity={severity}>
            {PopUpMessage}
          </Alert>
        </Snackbar>
      </div>
    </>
  )
}
export default TerminalHeaderFooter
